import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1a1c1b] border-t border-[var(--border-light)] pt-16 pb-8">
      <div className="container-custom mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-2">
            <h3 className="heading-3 mb-6">Soo Hoo Consulting</h3>
            <p className="body-medium text-gray-400 max-w-sm mb-6">
              Helping organizations go from the Now - to find their "New and Next" challenges.
            </p>
            <Link to="/contact" className="btn-secondary text-sm px-6 py-2">
              Contact Me
            </Link>
          </div>
          
          <div>
            <h4 className="font-bold text-white mb-4 uppercase tracking-wider">Services</h4>
            <ul className="space-y-2 body-medium text-sm">
              <li><Link to="/#services" className="hover:text-[var(--brand-primary)]">Leadership</Link></li>
              <li><Link to="/#services" className="hover:text-[var(--brand-primary)]">Transformation</Link></li>
              <li><Link to="/#services" className="hover:text-[var(--brand-primary)]">Innovation</Link></li>
              <li><Link to="/#services" className="hover:text-[var(--brand-primary)]">Technology</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold text-white mb-4 uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2 body-medium text-sm">
              <li><Link to="/privacy" className="hover:text-[var(--brand-primary)]">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[var(--brand-primary)]">Terms of Service</Link></li>
              <li><Link to="/refund" className="hover:text-[var(--brand-primary)]">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-[var(--border-light)] pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Soo Hoo Consulting. All rights reserved.</p>
          <p className="mt-2 md:mt-0">San Francisco, CA • ed@soohoo.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
